import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Monitoring Activities',
      type: 'table',
      watch: {
        '[]': [
          {
            '{}': {
              alias: 'sr.save-activity',
            },
          },
          {
            '{}': {
              alias: 'sr.delete-activity',
            },
          },
        ],
      },
      content: {
        '{}': {
          query: {
            '`': {
              target: 'ent:!subaward_monitor_acts:!activity',
              selection: {
                '{}': {
                  fields: {
                    '{}': {
                      name: {
                        '{}': {
                          value: {
                            '@.': '!name',
                          },
                        },
                      },
                      descr: {
                        '{}': {
                          value: {
                            '@.': '!descr',
                          },
                        },
                      },
                      always_recommend: {
                        '{}': {
                          value: {
                            '@.': '!always_recommend',
                          },
                        },
                      },
                      tc: {
                        '{}': {
                          value: {
                            '@': 'tcNames',
                          },
                        },
                      },
                    },
                  },
                  onEdit: {
                    '{}': {
                      action: {
                        '{}': {
                          payload: {
                            '{}': {
                              widget: {
                                '{}': {
                                  alias: 'sr.conditions.widgets.add-activity',
                                },
                              },
                              variables: {
                                '{}': {
                                  activityId: {
                                    '@.': '!id',
                                  },
                                },
                              },
                            },
                          },
                          operation: 'ui.modal',
                        },
                      },
                    },
                  },
                  onDelete: {
                    '{}': {
                      action: {
                        '{}': {
                          alias: 'sr.delete-activity',
                        },
                      },
                      confirm: {
                        '{}': {
                          title: 'Delete monitoring activity',
                          message:
                            'Are you sure that you want to delete monitoring activity?',
                        },
                      },
                      variables: {
                        '{}': {
                          activityId: {
                            '@.': '!id',
                          },
                        },
                      },
                    },
                  },
                },
              },
              subqueries: {
                tcMonitorActs: {
                  ref: {
                    attr: 'attr:ent#!subaward_tc_monitor_act#!entry:!activity',
                  },
                  target: 'ent:!subaward_tc_monitor_act:!entry',
                },
                tcNames: {
                  ref: {
                    attr: 'attr:ent#!subaward_tc_monitor_act#!entry:!tc',
                  },
                  using: 'tcMonitorActs',
                  target: 'ent:!subaward_tcs:!tc',
                  selection: {
                    '@.': '!name',
                  },
                },
              },
            },
          },
          onCreate: {
            '{}': {
              action: {
                '{}': {
                  payload: {
                    '{}': {
                      widget: {
                        '{}': {
                          alias: 'sr.conditions.widgets.add-activity',
                        },
                      },
                    },
                  },
                  operation: 'ui.modal',
                },
              },
            },
          },
          columns: {
            '[]': [
              {
                '{}': {
                  id: 'name',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subaward_monitor_acts#!activity:!name',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'descr',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subaward_monitor_acts#!activity:!descr',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'always_recommend',
                  dmsAttr: {
                    '{}': {
                      attributeId:
                        'attr:ent#!subaward_monitor_acts#!activity:!always_recommend',
                    },
                  },
                },
              },
              {
                '{}': {
                  id: 'tc',
                  dmsRef: {
                    '{}': {
                      source:
                        'attr:ent#!subaward_tc_monitor_act#!entry:!activity',
                      target: 'attr:ent#!subaward_tc_monitor_act#!entry:!tc',
                    },
                  },
                },
              },
            ],
          },
        },
      },
    },
  },
}
